import {connect} from "react-redux";
import ActivityCreate from "./create";
import {bindActionCreators} from "redux";
import {getActivity, getActivityById, saveActivity} from "../../../service/Lead/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {cancelActivity} from "../../../service/Activity/action";

const mapStateToProps = (state) => ({
    leadActivity:state.Lead.leadActivity,
    leadActivityById:state.Lead.leadActivityById,
    saveLeadActivity:state.Lead.saveLeadActivity,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    cancelActivityDetails:state.Activity.cancelActivity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getActivity,
            getActivityById,
            documentUploadUrlPublic,
            saveActivity,
            cancelActivity,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCreate);
